import Vue from "vue";

export const store = Vue.observable({
	bindingCharge: 0,
	bindingName: null,
	bindingOptions: [],
	blankEnvelopeCharge: 0,
	bleedCost: 1,
	calculator: null,
	clickCharge: 0,
	coatingCharge: 0,
	coatingOptions: [],
	coilPlasticColorCharge: 0,
	coilWireoColorCharge: 0,
	cornerRoundingCharge: 0,
	costFactor: 0,
	coverBackCharge: 0,
	coverFrontCharge: 0,
	coverInkCharge: 0,
	coverPaperCharge: 0,
	coverPaperWeight: 0,
	drillingCharge: 0,
	foldingCharge: 0,
	landscapePremium: 1,
	padding: 1,
	pageDiscount: 0,
	pages: 0,
	paperCharge: 0,
	paperIsCover: false,
	paperLength: 0,
	paperWeight: 0,
	paperWidth: 0,
	productId: null,
	productionCost: 1,
	proofCharge: 0,
	qty: 0,
	setupCosts: [],
	shrinkWrapCharge: 0,
	sizeFactor: 0,
	sizeSquareInches: 0,
	standardSheetSize: 12 * 18,
	totalCompletedFields: 0,
	totalRequiredFields: 0
});

export const mutations = {
	/**
	 * Ensures completed and required fields are properly tallied
	 * for the special case of coating only being visible when a
	 * cover stock is chosen (poster calculator only).
	 */
	checkFieldCount(isCover) {
		if (store.calculator === "poster") {
			if (isCover === "false" && store.paperIsCover === "true") {
				if (store.coatingCharge !== 0) {
					mutations.subtractCompletedField();
				}

				mutations.subtractRequiredField();
				store.coatingCharge = 0;
			}
		}
	},

	disableIncompatibleBinding(pages) {
		store.bindingOptions.forEach(e => {
			e.disabled = false;

			if (e.maxPages < pages) {
				e.disabled = true;
			}
		});

		if (!store.bindingOptions.length) {
			store.bindingCharge = 0;
		}
	},

	setBindingCharge(bindingCharge) {
		store.bindingCharge = bindingCharge;
	},

	setBindingOptions(options) {
		options.forEach(e => {
			store.bindingOptions.push({
				name: e.name,
				multiplier: Number(e.multiplier),
				coating: e.compatible_coating
					? e.compatible_coating.join()
					: null,
				hasColorOptions: e.has_color_options,
				maxPages: Number(e.max_pages),
				disabled: false // e.is_disabled
			});
		});
	},

	setBindingName(bindingName) {
		store.bindingName = bindingName;
	},

	setBlankEnvelopeCharge(blankEnvelopeCharge) {
		store.blankEnvelopeCharge = blankEnvelopeCharge;
	},

	setBleedCost(bleedCost) {
		store.bleedCost = 1 + bleedCost / 100;
	},

	setCalculator(type) {
		store.calculator = type;
	},

	setClickCharge(clickCharge) {
		store.clickCharge = clickCharge;
	},

	setCoatingCharge(coatingCharge) {
		store.coatingCharge = coatingCharge;
	},

	setCoatingOptions(options) {
		options.forEach(e => {
			store.coatingOptions.push(e.name);
		});
	},

	setCoilPlasticColorCharge(coilPlasticColorCharge) {
		store.coilPlasticColorCharge = coilPlasticColorCharge;
		store.coilWireoColorCharge = 0;
	},

	setCoilWireoColorCharge(coilWireoColorCharge) {
		store.coilWireoColorCharge = coilWireoColorCharge;
		store.coilPlasticColorCharge = 0;
	},

	setCompatibleCoating(e) {
		if (e.target.selectedIndex) {
			store.coatingOptions = e.target.options[
				e.target.selectedIndex
			].attributes.coating.value.split(",");
		}
	},

	setCornerRoundingCharge(cornerRoundingCharge) {
		store.cornerRoundingCharge = cornerRoundingCharge;
	},

	setCoverBackCharge(coverBackCharge) {
		store.coverBackCharge = coverBackCharge;
	},

	setCoverFrontCharge(coverFrontCharge) {
		store.coverFrontCharge = coverFrontCharge;
	},

	setCostFactor(costFactor) {
		store.costFactor = costFactor;
	},

	setCoverInkCharge(coverInkCharge) {
		store.coverInkCharge = coverInkCharge;
	},

	setCoverPaperCharge(coverPaperCharge) {
		store.coverPaperCharge = coverPaperCharge;
	},

	setCoverPaperWeight(e) {
		let weight =
			e.target.options[e.target.selectedIndex].attributes.weight.value;
		store.coverPaperWeight = weight;
	},

	setDrillingCharge(drillingCharge) {
		store.drillingCharge = drillingCharge;
	},

	setFoldingCharge(foldingCharge) {
		store.foldingCharge = foldingCharge;
	},

	setLandscapePremium(landscapePremium) {
		store.landscapePremium = 1 + landscapePremium / 100;
	},

	setPaperCharge(paperCharge) {
		store.paperCharge = paperCharge;
	},

	setPaperIsCover(e) {
		let isCover =
			e.target.options[e.target.selectedIndex].attributes.cover.value;

		mutations.checkFieldCount(isCover);

		store.paperIsCover = isCover;
	},

	setPaperWeightPerSheet(e) {
		let weight =
			e.target.options[e.target.selectedIndex].attributes.weight.value;
		store.paperWeight = weight;
	},

	setPadding(padding) {
		store.padding = padding;
	},

	setPageDiscount(pageDiscount) {
		store.pageDiscount = pageDiscount;
	},

	setPages(pages) {
		store.pages = pages;
	},

	setProductId(pid) {
		store.productId = pid;
	},

	setProductionCost(productionCost) {
		store.productionCost = 1 + productionCost / 100;
	},

	setProofCharge(proofCharge) {
		store.proofCharge = proofCharge;
	},

	setQty(qty) {
		store.qty = qty;
	},

	setSetupCosts(options) {
		options[0].data.forEach(e => {
			store.setupCosts.push({
				cost: Number(e.cost),
				min: Number(e.min_quantity),
				max: Number(e.max_quantity)
			});
		});
	},

	setShrinkWrapCharge(shrinkWrapCharge) {
		store.shrinkWrapCharge = shrinkWrapCharge;
	},

	setSizeFactor(sizeFactor) {
		store.sizeFactor = sizeFactor;
	},

	setSizeSquareInches(width, length) {
		store.paperWidth = width;
		store.paperLength = length;
		store.sizeSquareInches = width * length;
	},

	subtractCompletedField() {
		store.totalCompletedFields--;
	},

	subtractRequiredField() {
		store.totalRequiredFields--;
	},

	tallyCompletedField() {
		store.totalCompletedFields++;
	},

	tallyRequiredField() {
		store.totalRequiredFields++;
	}
};
